<template>
  <div class="hello flex">
    <section class="info">
      <div class="head">当前信息</div>
      <p>{{user.province_name}}丨{{user.city_name}}丨{{user.county_name}}</p>
      <p>{{user.school}}</p>

      <p>年级:{{user.grade_name}}</p>
      <p>班级:{{user.class}}</p>
      <!-- <button class="edit" @click="dialogVisible=true">
        修改信息
      </button> -->
    </section>

    <div style="width:1050px!important;text-align: left;margin-top:20px;">
      <el-page-header @back="goBack" content="详情页面">
      </el-page-header>
      <div class="flex headinfo">
        <p>{{user.province_name}}丨{{user.city_name}}丨{{user.county_name}}</p>
        <p>{{user.school}}</p>

        <p>年级:{{user.grade_name}}</p>
        <p>班级:{{user.class}}</p>
      </div>
      <el-table :data="tableData" stripe style="width: 1050px!important;">
        <el-table-column label="科目" prop="type_zn"></el-table-column>
        <el-table-column label="分数" prop="score"></el-table-column>
        <el-table-column label="提高/下滑">
          <templete slot-scope="scope" class="score">
            <span style="margin-right: 10px;" v-show="scope.row.change==-1">下滑</span>
            <span style="margin-right: 10px;" v-show="scope.row.change==0">稳定</span>
            <span style="margin-right: 10px;" v-show="scope.row.change==1">上升</span>
            <img style="vertical-align: middle;" v-show="scope.row.change==-1" src="../../../assets/down.png" alt="">
            <img style="vertical-align: middle;" v-show="scope.row.change==1" src="../../../assets/up.png" alt="">
          </templete>
        </el-table-column>

        <el-table-column label="预估下次分数区间">
          <templete slot-scope="scope" class="score">
            {{scope.row.pre_min}} - {{scope.row.pre_max}}
          </templete>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;font-weight: bold;">
        <span>
          <span>总分：{{data.total}}</span>
          <img style="vertical-align: middle;" v-show="data.total_change==-1" src="../../../assets/down.png" alt="">
          <img style="vertical-align: middle;" v-show="data.total_change==1" src="../../../assets/up.png" alt="">
        </span>
        <span style="margin-left: 40px;">下次成绩预估区间：{{data.total_pre_min}} - {{data.total_pre_max}}</span>
        <span style="margin-left: 40px;">评语：{{data.tips}}</span>
      </div>
      <div class="tips flex">
        <span style="">学习状态：</span>
        <div>{{data.tips2}}</div>
      </div>
      <div class="tips1 flex" v-if="data.low_subjects.length!=0">
        <span style="">薄弱科目：</span>
        <div> <span style="margin-left: 0;" v-for="(item,index) in data.low_subjects">{{item}}</span></div>
      </div>
      <div class="tips flex">
        <span style="">相对薄弱：

        </span>
        <div>
          <span style="margin-right: 10px;" v-for="(item,index) in data.min_subjects">{{item}}</span>
        </div>
      </div>
    </div>
    <el-dialog title="请输入学校信息" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <div class="flex one">
        <span>所在省份：</span>
        <div>
          <el-select v-model="user.province_name" @change="change0($event)" style="width: 150px;">
            <el-option v-for="item in province" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="user.city_name" @change="change($event)" style="width: 150px;">
            <el-option v-for="item in city" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="user.county_name" @change="change1($event)" style="width: 150px;">
            <el-option v-for="item in county" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="one">
        <span>学校名称:</span>
        <el-input style="width: 200px;" v-model="user.school" placeholder="请输入内容"></el-input>
      </div>
      <div class="flex one">
        <span>年级：</span>
        <div>
          <el-select v-model="user.grade_name" @change="change0($event)" style="width:200px;">
            <el-option v-for="item in options.grade_list" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="one">
        <span>班级:</span>
        <el-input style="width: 200px;" v-model="user.class" placeholder="请输入内容"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        dialogVisible: false,
        tableData: [],
        userInfo: [],
        user: [],
        options: [],
        province: [],
        city: [],
        county: []
      }
    },
    components: {

    },
    created() {
      this.$http.userExamScoreDetail({
        id: this.$route.query.id
      }).then(res => {
        this.data = res.data
        this.tableData = res.data.scores
        console.log(this.tableData)
      })
      this.$http.userExamInfo().then(res => {
        this.user = res.data.info
        this.options = res.data
      })
    },
    mounted() {

    },
    methods: {
      goBack() {
        this.$router.push('/growthRecord')
      },
      submit() {
        localStorage.setItem('user', JSON.stringify(this.user))
        this.$router.push('/addRecord')
      },
      add() {
        this.dialogVisible = true
        // this.$router.push('/addRecord')
      },
      change1(e) {
        this.user.county_id = e
      },
      change(e) {
        this.user.city_id = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.county = res.data.list
        })
      },
      change0(e) {
        console.log(e)
        this.user.city = null
        this.user.county = null
        this.user.county_name = ''
        this.user.city_name = ''
        this.user.province_id = e
        this.$http.getareaList({
          pid: e
        }).then(res => {
          this.city = res.data.list
        })
        this.$http.subjectTypeList({
          province_id: e,
        }).then(res => {
          this.type = res.data.type
          if (res.data.type == 2) {
            this.options3 = res.data.select[1]
          } else {
            this.options3 = res.data.select
          }

        })
      },

    }
  }
</script>

<style scoped lang="scss">
  $color:#C10B17;

  .tips,
  .tips1 {
    margin: 20px 0;
    font-weight: bold;

    div>span {
      margin-right: 10px;
    }
  }

  .dialog-title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  .add {
    width: 100%;
    height: 50px;
    background-color: #C10B17;
    color: #FFFFFF;
    border-radius: 10px;
    font-size: 16px;
    margin-bottom: 30px;
  }

  .headinfo {
    margin: 20px 0;

    p {
      margin-right: 20px;
    }
  }

  .one {
    margin: 20px 0;
    text-align: left;

    span {
      display: inline-block;
      width: 80px;
    }
  }

  .hello {
    justify-content: space-between;
    align-items: flex-start;
  }

  .edit {
    width: 147px;
    height: 33px;
    border: 1px solid #C10B17;
    border-radius: 6px;
    background-color: #FFFFFF;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #C10B17;
    margin-top: 15px;
  }

  .info {
    min-width: 175px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;
    border: 1px solid #EDEDED;
    text-align: center;
    padding-bottom: 20px;



    &>p {
      width: 100%;

      margin: 20px 0px 20px 0px;
    }

    .head {
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }

    .score {
      img {
        vertical-align: middle;
      }

      margin-right: 10px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/view/me/growthRecord/growthDetail.vue